import React, { ComponentType, LazyExoticComponent } from "react";
import { loadRemoteModule } from "@coxauto-ui/core/module-federation";

export const CustomerCardModule = React.lazy(
  () => import("customer/CustomerCardModule")
);

export const CustomerSidebarModule = React.lazy(
  () => import("customer/CustomerSidebarModule")
);

export const CustomerConversationModule = React.lazy(
  () => import("communications/CustomerConversationModule")
);

export interface AdminModuleProps {
  getAuthOverride: () => Promise<string>;
}

// Loaded via the runtime module-federation helper (not a static `import()`) so the
// host's React stays the resolved shared singleton. A static federated import resolves
// the shared React to the highest version in the build (the remote's), which breaks the
// host's dev `jsx-dev-runtime` (ReactDebugCurrentFrame undefined) when serving in dev.
export const AdminModule: LazyExoticComponent<ComponentType<AdminModuleProps>> =
  React.lazy(() => loadRemoteModule("tenant-admin", "./AdminModule"));
